export const USER_TICKETS_REQUEST = "USER_TICKETS_REQUEST";
export const USER_TICKETS_SUCCESS = "USER_TICKETS_SUCCESS";
export const USER_TICKETS_FAIL = "USER_TICKETS_FAIL";
export const SINGLE_TICKET_REQUEST = "SINGLE_TICKET_REQUEST";
export const SINGLE_TICKET_SUCCESS = "SINGLE_TICKET_SUCCESS";
export const SINGLE_TICKET_FAIL = "SINGLE_TICKET_FAIL";
export const SINGLE_TICKET_RESET = 'SINGLE_TICKET_REST';
